// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__2r4hO","InlineForm":"Form_InlineForm__3yc-f"};